import * as React from "react";

import "./CustomRadio.scss";

const CustomRadio = (props) => {
  const { label, id, icone, ...rest } = props;

  const inputId = id || `radio-${Math.floor(Math.random() * 1000)}`;

  return (
    <>
      <label className="container-radio" htmlFor={inputId}>
        <input type="radio" id={inputId} {...rest} />
        <div className="wrap-label-icone">
          {icone ? icone : ""}
          {label}
        </div>
        <span className="checkmark"></span>
      </label>
    </>
  );
};

export default CustomRadio;
